import * as _ from "lodash";
import {
  _makeJHHApiCall,
  _setItemInLocalEncrypted,
  _getItemFromLocalDecrypted,
  _getAccessToken
} from "network-helper";
import config from "../config.json";
import { inputParams } from "./GetCommonParam";
import { _setRequestToken } from "./JHHToken";

const fallbackErrorMessage = "Something went wrong. Please try again.";


export const _setAccessTokenHeader = async () => {
  const result = await _setRequestToken({});
  const status = _.get(result, "status", "");
  const token = _.get(result, "token", "");
  //todo add an api resp enum
  if (status === "success") {
    return token;
  }
};

export const handleApiCall = async (
  { ...rest },
  isJHHTokenRequired = false,
  isDeviceDetailsRequired = false,
) => {
  try {
    if (isJHHTokenRequired === true) {
      const accessToken =
        _getAccessToken() === null
          ? await _setAccessTokenHeader()
          : _getAccessToken();
      _.set(rest, "headers.token", accessToken);
    }
    const EnvArray = [
      config.JHHMainEnv,
      config.JHHAppIntegrationService,
      config.JHHPatientAppEnv
    ];
    if (
      isDeviceDetailsRequired &&
      rest.url.length &&
      EnvArray.find((url) => rest.url.includes(url)) !== undefined
    ) {
      rest = {
        ...rest,
        dataObj: {
          ...rest.dataObj,
          ...inputParams(),
        },
      };
    }
    const clonedRest = _.cloneDeep(rest);
    const jhhAPIResponse = await _makeJHHApiCall({ ...clonedRest });
    return jhhAPIResponse;
  } catch (err) {
    const statusCode = _.get(err, "response.status");
    const apiErrorMessage = _.get(err, "response.data.message", fallbackErrorMessage);
    if (statusCode === 401 && isJHHTokenRequired === true) {
      throw err;
    } else {
      return { status: 'error', message: apiErrorMessage }
    }
  }
};